<template>
  <div class="element-board-item" :class="{ on }" @click.lazy="$emit( 'clickLazy' )" @click="$emit( 'click' )">
    <slot />
  </div>
</template>
<script>
export default {
  props: [ "on" ]

}
</script>
